// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Manual Assessment Styles - Matching MCQ Component */

.mcqMainDiv {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
}

/* Main Container */
.mcqContainer {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 24px;
    max-width: 1600px;
    margin: 0 auto;
    width: 100%;
}

@media (max-width: 1200px) {
    .mcqContainer {
        grid-template-columns: 1fr;
    }
    
    .mcqSidebarSection {
        order: -1;
        margin-bottom: 24px;
    }
}

/* Question Section */
.mcqQuestionSection {
    display: flex;
    flex-direction: column;
}

.mcqQuestionCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    transition: all 0.3s ease !important;
}

.mcqQuestionCard:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
}

.mcqQuestionCard .ant-card-body {
    padding: 32px !important;
}

/* Question Header */
.mcqQuestionHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
}

.mcqQuestionHeaderLeft {
    display: flex;
    align-items: center;
    gap: 16px;
}

.mcqQuestionNumberBadge {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
    border-radius: 12px;
}

.mcqQuestionIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.mcqQuestionNumber {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

.mcqTimerBadge {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);
    border: 1px solid rgba(245, 87, 108, 0.2);
    border-radius: 12px;
}

.mcqTimerIcon {
    font-size: 20px !important;
    color: #f5576c !important;
}

.mcqTimerText {
    font-size: 16px;
    font-weight: 600;
    color: #f5576c;
    font-variant-numeric: tabular-nums;
}

/* Progress Bar */
.mcqProgressBar {
    margin-bottom: 32px;
}

.mcqProgressBar .ant-progress-bg {
    border-radius: 10px;
}

/* Question Content */
.mcqQuestionContent {
    margin-bottom: 32px;
}

.mcqQuestionText {
    font-size: 18px;
    line-height: 1.8;
    color: #1f2937;
    margin-bottom: 32px;
    font-weight: 500;
}

.mcqQuestionText img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    margin: 16px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.questionCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    transition: all 0.3s ease !important;
}

.questionCard:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
}

.questionCard .ant-card-body {
    padding: 32px !important;
}

.QuestionHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
}

.Ques-txt {
    font-size: 16px;
    font-weight: 600;
    color: #667eea;
}

/* Options Container */
.mcqOptionsContainer {
    margin-top: 24px;
}

.mcqTextInput {
    border-radius: 12px !important;
    padding: 12px 16px !important;
    font-size: 16px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    transition: all 0.3s ease !important;
}

.mcqTextInput:focus,
.mcqTextInput:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.mcqRadioGroup,
.mcqCheckboxGroup {
    width: 100%;
}

.mcqOptionItem {
    padding: 16px 20px;
    border: 2px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #ffffff;
    margin-bottom: 12px;
}

.mcqOptionItem:hover {
    border-color: rgba(102, 126, 234, 0.4);
    background: rgba(102, 126, 234, 0.05);
    transform: translateX(4px);
}

.mcqOptionItem.radioOption {
    display: flex;
    align-items: center;
}

.mcqOptionItem.checkboxOption {
    display: flex;
    align-items: flex-start;
}

.mcqRadio,
.mcqCheckbox {
    margin: 0 !important;
    width: 100%;
}

.mcqRadio .ant-radio-inner,
.mcqCheckbox .ant-checkbox-inner {
    width: 22px;
    height: 22px;
    border-color: #667eea;
}

.mcqRadio .ant-radio-checked .ant-radio-inner,
.mcqCheckbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #667eea;
    border-color: #667eea;
}

.mcqOptionText {
    font-size: 16px;
    color: #1f2937;
    line-height: 1.6;
    margin-left: 12px;
}

/* Navigation Buttons */
.mcqNavigationButtons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-top: 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.mcqNavButton {
    height: 48px !important;
    padding: 0 32px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    transition: all 0.3s ease !important;
}

.mcqNavButton.prevButton {
    background: #ffffff !important;
    border: 2px solid rgba(102, 126, 234, 0.3) !important;
    color: #667eea !important;
}

.mcqNavButton.prevButton:hover {
    background: rgba(102, 126, 234, 0.05) !important;
    border-color: #667eea !important;
    transform: translateX(-2px);
}

.mcqNavButton.nextButton,
.mcqNavButton.finishButton {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
}

.mcqNavButton.nextButton:hover,
.mcqNavButton.finishButton:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
}

.mcqNavButton.finishButton {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4) !important;
}

.mcqNavButton.finishButton:hover {
    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5) !important;
}

/* Sidebar Section */
.mcqSidebarSection {
    display: flex;
    flex-direction: column;
}

.mcqSidebarCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    position: sticky;
    top: 90px;
}

.mcqSidebarCard .ant-card-body {
    padding: 24px !important;
}

.mcqSidebarHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.mcqSidebarIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.mcqSidebarTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

/* Question Chart */
.mcqQuestionChart {
    margin-bottom: 24px;
}

.answerImageQuestionInput {
    border-radius: 12px !important;
    padding: 12px 16px !important;
    font-size: 16px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    transition: all 0.3s ease !important;
}

.answerImageQuestionInput:focus,
.answerImageQuestionInput:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.questionChartItemsDiv {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
}

.questionChartItems {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(102, 126, 234, 0.2);
    border-radius: 8px;
    cursor: pointer;
    background: #ffffff;
    transition: all 0.3s ease;
}

.questionChartItems:hover {
    border-color: #667eea;
    background: rgba(102, 126, 234, 0.1);
}

.questionChartItemsSelected {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #667eea;
    border-radius: 8px;
    cursor: pointer;
    background: #667eea;
    color: #ffffff;
    transition: all 0.3s ease;
}

.questionChartItemsSelected:hover {
    background: #764ba2;
    border-color: #764ba2;
}

.questionChartItems p,
.questionChartItemsSelected p {
    margin: 0;
    font-weight: 600;
    font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .mcqMainDiv {
        padding: 20px;
    }
    
    .questionCard .ant-card-body {
        padding: 20px !important;
    }
    
    .mcqOptionItem {
        padding: 12px 16px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/ManualAssessment/ManualAssessment.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8FAA8F;IAC9F,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,4FAA4F;IAC5F,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;;IAEI,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;;IAEI,wEAAwE;IACxE,uBAAuB;IACvB,0DAA0D;AAC9D;;AAEA;;IAEI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,wEAAwE;IACxE,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;;IAEI,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Manual Assessment Styles - Matching MCQ Component */\n\n.mcqMainDiv {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n}\n\n/* Main Container */\n.mcqContainer {\n    display: grid;\n    grid-template-columns: 1fr 320px;\n    gap: 24px;\n    max-width: 1600px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n@media (max-width: 1200px) {\n    .mcqContainer {\n        grid-template-columns: 1fr;\n    }\n    \n    .mcqSidebarSection {\n        order: -1;\n        margin-bottom: 24px;\n    }\n}\n\n/* Question Section */\n.mcqQuestionSection {\n    display: flex;\n    flex-direction: column;\n}\n\n.mcqQuestionCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqQuestionCard:hover {\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;\n}\n\n.mcqQuestionCard .ant-card-body {\n    padding: 32px !important;\n}\n\n/* Question Header */\n.mcqQuestionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.mcqQuestionHeaderLeft {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.mcqQuestionNumberBadge {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 20px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    border-radius: 12px;\n}\n\n.mcqQuestionIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.mcqQuestionNumber {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n}\n\n.mcqTimerBadge {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n    border-radius: 12px;\n}\n\n.mcqTimerIcon {\n    font-size: 20px !important;\n    color: #f5576c !important;\n}\n\n.mcqTimerText {\n    font-size: 16px;\n    font-weight: 600;\n    color: #f5576c;\n    font-variant-numeric: tabular-nums;\n}\n\n/* Progress Bar */\n.mcqProgressBar {\n    margin-bottom: 32px;\n}\n\n.mcqProgressBar .ant-progress-bg {\n    border-radius: 10px;\n}\n\n/* Question Content */\n.mcqQuestionContent {\n    margin-bottom: 32px;\n}\n\n.mcqQuestionText {\n    font-size: 18px;\n    line-height: 1.8;\n    color: #1f2937;\n    margin-bottom: 32px;\n    font-weight: 500;\n}\n\n.mcqQuestionText img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 12px;\n    margin: 16px 0;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.questionCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    transition: all 0.3s ease !important;\n}\n\n.questionCard:hover {\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;\n}\n\n.questionCard .ant-card-body {\n    padding: 32px !important;\n}\n\n.QuestionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.Ques-txt {\n    font-size: 16px;\n    font-weight: 600;\n    color: #667eea;\n}\n\n/* Options Container */\n.mcqOptionsContainer {\n    margin-top: 24px;\n}\n\n.mcqTextInput {\n    border-radius: 12px !important;\n    padding: 12px 16px !important;\n    font-size: 16px !important;\n    border: 2px solid rgba(102, 126, 234, 0.2) !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqTextInput:focus,\n.mcqTextInput:hover {\n    border-color: #667eea !important;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;\n}\n\n.mcqRadioGroup,\n.mcqCheckboxGroup {\n    width: 100%;\n}\n\n.mcqOptionItem {\n    padding: 16px 20px;\n    border: 2px solid rgba(0, 0, 0, 0.06);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background: #ffffff;\n    margin-bottom: 12px;\n}\n\n.mcqOptionItem:hover {\n    border-color: rgba(102, 126, 234, 0.4);\n    background: rgba(102, 126, 234, 0.05);\n    transform: translateX(4px);\n}\n\n.mcqOptionItem.radioOption {\n    display: flex;\n    align-items: center;\n}\n\n.mcqOptionItem.checkboxOption {\n    display: flex;\n    align-items: flex-start;\n}\n\n.mcqRadio,\n.mcqCheckbox {\n    margin: 0 !important;\n    width: 100%;\n}\n\n.mcqRadio .ant-radio-inner,\n.mcqCheckbox .ant-checkbox-inner {\n    width: 22px;\n    height: 22px;\n    border-color: #667eea;\n}\n\n.mcqRadio .ant-radio-checked .ant-radio-inner,\n.mcqCheckbox .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #667eea;\n    border-color: #667eea;\n}\n\n.mcqOptionText {\n    font-size: 16px;\n    color: #1f2937;\n    line-height: 1.6;\n    margin-left: 12px;\n}\n\n/* Navigation Buttons */\n.mcqNavigationButtons {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    padding-top: 24px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.mcqNavButton {\n    height: 48px !important;\n    padding: 0 32px !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    border-radius: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqNavButton.prevButton {\n    background: #ffffff !important;\n    border: 2px solid rgba(102, 126, 234, 0.3) !important;\n    color: #667eea !important;\n}\n\n.mcqNavButton.prevButton:hover {\n    background: rgba(102, 126, 234, 0.05) !important;\n    border-color: #667eea !important;\n    transform: translateX(-2px);\n}\n\n.mcqNavButton.nextButton,\n.mcqNavButton.finishButton {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;\n}\n\n.mcqNavButton.nextButton:hover,\n.mcqNavButton.finishButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;\n}\n\n.mcqNavButton.finishButton {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4) !important;\n}\n\n.mcqNavButton.finishButton:hover {\n    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5) !important;\n}\n\n/* Sidebar Section */\n.mcqSidebarSection {\n    display: flex;\n    flex-direction: column;\n}\n\n.mcqSidebarCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    position: sticky;\n    top: 90px;\n}\n\n.mcqSidebarCard .ant-card-body {\n    padding: 24px !important;\n}\n\n.mcqSidebarHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.mcqSidebarIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.mcqSidebarTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n/* Question Chart */\n.mcqQuestionChart {\n    margin-bottom: 24px;\n}\n\n.answerImageQuestionInput {\n    border-radius: 12px !important;\n    padding: 12px 16px !important;\n    font-size: 16px !important;\n    border: 2px solid rgba(102, 126, 234, 0.2) !important;\n    transition: all 0.3s ease !important;\n}\n\n.answerImageQuestionInput:focus,\n.answerImageQuestionInput:hover {\n    border-color: #667eea !important;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;\n}\n\n.questionChartItemsDiv {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n\n.questionChartItems {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid rgba(102, 126, 234, 0.2);\n    border-radius: 8px;\n    cursor: pointer;\n    background: #ffffff;\n    transition: all 0.3s ease;\n}\n\n.questionChartItems:hover {\n    border-color: #667eea;\n    background: rgba(102, 126, 234, 0.1);\n}\n\n.questionChartItemsSelected {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid #667eea;\n    border-radius: 8px;\n    cursor: pointer;\n    background: #667eea;\n    color: #ffffff;\n    transition: all 0.3s ease;\n}\n\n.questionChartItemsSelected:hover {\n    background: #764ba2;\n    border-color: #764ba2;\n}\n\n.questionChartItems p,\n.questionChartItemsSelected p {\n    margin: 0;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .mcqMainDiv {\n        padding: 20px;\n    }\n    \n    .questionCard .ant-card-body {\n        padding: 20px !important;\n    }\n    \n    .mcqOptionItem {\n        padding: 12px 16px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
